/* global */
/* eslint-disable */
/* eslint-disable */
webpackJsonp([14],{

	/***/ 										10:
	/***/ (function(module, exports, __webpack_require__) {

		"use strict"

		var _timelinelite = __webpack_require__(0);

		var _timelinelite2 = _interopRequireDefault(_timelinelite);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var ease = window.Power4.easeInOut;
		var ease2 = window.Power4.easeOut;

		/**
		 * Hero animation
		 */

		var t1 = new _timelinelite2.default();
		var hero = document.querySelector(".js-tru-hero");

		function onHeroHeadingComplete(){

			var truGraphics = document.querySelector(".js-hero-graphics");

			setTimeout(function(){
				truGraphics.classList.add("animation");
			}, 600);

		}

		const heroObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {

					t1.addLabel("start"); // start time = 0

					// animate position and alpha transparency of elements

					t1.fromTo(".js-hero-sphare", 1, { autoAlpha: 0}, { autoAlpha: 1, ease: ease });
					t1.fromTo(".js-tru-logo", 1, { y: "-10px", autoAlpha: 0 }, { y: "0", autoAlpha: 1, ease: ease }, "start+=0.35");

					t1.staggerFromTo(".js-hero-heading span", 0.5, { y: "-40px", autoAlpha: 0 }, { y: "0", autoAlpha: 1, onComplete: onHeroHeadingComplete}, 0.15, "start-=0.1");

					if (entry.intersectionRatio > 0) {
						heroObserver.unobserve(entry.target);
					}

				}
			})
		},
		{
			threshold: "0.25"
		});

		heroObserver.observe(hero);

		/**
		 * about section animation
		 */

		var aboutSection = document.querySelector(".js-about-section");
		var t2 = new _timelinelite2.default();

		const aboutObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {

					t2.addLabel("start"); // start time = 0

					// animate position and alpha transparency of elements

					t2.staggerFromTo(".js-about-content p", 1, { y: "-10px", autoAlpha: 0 }, { y: "0", autoAlpha: 1 }, 0.15, "start+=1");

					if (entry.intersectionRatio > 0) {
						aboutObserver.unobserve(entry.target);
					}

				}
			})
		},
		{
			threshold: "0.25"
		});

		aboutObserver.observe(aboutSection);

		/**
		 * download form animation
		 */

		var formSection = document.querySelector(".js-tru-form-section");
		var t3 = new _timelinelite2.default();

		const downloadObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {

					t3.addLabel("start"); // start time = 0

					// animate position and alpha transparency of elements

					t3.fromTo(".js-tru-from-heading", 1, { y: "-10px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease });
					t3.staggerFromTo(".js-form-list li", 0.5, { y: "-10px", autoAlpha: 0 }, { y: "0", autoAlpha: 1}, 0.15, "start+=0.25");
					t3.fromTo(".js-form-box", 1.25, { y: "-10px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=0.25");

					if (entry.intersectionRatio > 0) {
						downloadObserver.unobserve(entry.target);
					}

				}
			})
		},
		{
			threshold: "0.25"
		});

		downloadObserver.observe(formSection);

		/**
		 * slides animation
		 */

		var slideTimeline, slideCount, slideBox, slideHeading, slideMesh, slideTxt, slideDiagram, slideDiagramSet1, slideDiagramSet2, slideDiagramSet3, slideDiagramSet4, slideDiagramSet5, slideDiagramSet6, slideDiagramSet7, slideDiagramSet8, slideDiagramSet9, slideDiagramSet10;

		document.querySelectorAll(".js-slide").forEach((el, i) => {

			const slideObserver = new IntersectionObserver(entries => {
				entries.forEach(entry => {

					if(entry.isIntersecting) {

						// slide interance animation

						slideTimeline = new _timelinelite2.default();
						slideCount = el.querySelectorAll(`:scope ${".q-tru-slide-count"}`);
						slideBox = el.querySelectorAll(`:scope ${".q-tru-slide-box--inner"}`);

						slideTimeline.fromTo(slideCount, 1, { y: "-70px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=0.25");
						slideTimeline.fromTo(slideBox,1, { y: "30px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=0.25");

						// slide content content animation

						if(el.classList.contains("willAnimate")) {

							slideHeading = el.querySelectorAll(`:scope ${".js-slide-heading span"}`);
							slideMesh = el.querySelector(`:scope ${".js-slide-graphics"}`);
							slideTxt = el.querySelector(`:scope ${".js-slide-txt"}`);
							slideDiagram = el.querySelector(`:scope ${".svg-diagram"}`);

							slideTimeline.staggerFromTo(slideHeading, 0.55, { y: "-10px", autoAlpha: 0 }, { y: "0", autoAlpha: 1}, 0.15, "start+=0.65");

							setTimeout(function(){
								slideMesh.classList.add("animation");
							}, 1200);

							slideTimeline.fromTo(slideTxt, 1, { y: "30px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=0.75");

							// slide #1 diagram animation

							if( slideDiagram.classList.contains("diagram-1") ){

								slideDiagramSet1 = slideDiagram.querySelector(`:scope ${".blue-bar"}`);
								slideDiagramSet2 = slideDiagram.querySelector(`:scope ${".gray-bar"}`);
								slideDiagramSet3 = slideDiagram.querySelector(`:scope ${".blue-text"}`);
								slideDiagramSet4 = slideDiagram.querySelector(`:scope ${".blue-bar-red-txt"}`);
								slideDiagramSet5 = slideDiagram.querySelector(`:scope ${".green-bar"}`);
								slideDiagramSet6 = slideDiagram.querySelector(`:scope ${".green-text"}`);
								slideDiagramSet7 = slideDiagram.querySelector(`:scope ${".expl-txt"}`);
								slideDiagramSet8 = slideDiagram.querySelector(`:scope ${".expl-range"}`);
								slideDiagramSet9 = slideDiagram.querySelector(`:scope ${".remd-txt"}`);
								slideDiagramSet10 = slideDiagram.querySelector(`:scope ${".remd-range"}`);

								slideTimeline.fromTo(slideDiagramSet1, 1.5, { x: "-50px", autoAlpha: 0}, { x: "0", autoAlpha: 1, ease: ease }, "start+=1.75");
								slideTimeline.fromTo(slideDiagramSet2, 1.5, { x: "-50px", autoAlpha: 0}, { x: "0", autoAlpha: 1, ease: ease }, "start+=1.85");
								slideTimeline.fromTo(slideDiagramSet3, 1.5, { x: "20px", autoAlpha: 0}, { x: "0", autoAlpha: 1, ease: ease }, "start+=2.35");
								slideTimeline.fromTo(slideDiagramSet4, 1.5, { x: "20px", autoAlpha: 0}, { x: "0", autoAlpha: 1, ease: ease }, "start+=2.45");

								slideTimeline.fromTo(slideDiagramSet5, 1.5, { x: "-50px", autoAlpha: 0}, { x: "0", autoAlpha: 1, ease: ease }, "start+=2.65");
								slideTimeline.fromTo(slideDiagramSet6, 1.5, { x: "20px", autoAlpha: 0}, { x: "0", autoAlpha: 1, ease: ease }, "start+=2.85");

								slideTimeline.fromTo(slideDiagramSet7, 1, { y: "-20px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=4.15");
								slideTimeline.fromTo(slideDiagramSet8, 1, { y: "20px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=4.35");

								slideTimeline.fromTo(slideDiagramSet9, 1, { y: "50px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=4.45");
								slideTimeline.fromTo(slideDiagramSet10, 1, { y: "-20px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=4.65");

							}

							// slide #2 diagram animation

							else if( slideDiagram.classList.contains("diagram-2") ) {


								slideDiagramSet1 = slideDiagram.querySelector(`:scope ${".seq1-graph-base"}`);
								slideDiagramSet2 = slideDiagram.querySelector(`:scope ${".seq2-header-1"}`);
								slideDiagramSet3 = slideDiagram.querySelector(`:scope ${".seq3-graph-1"}`);
								slideDiagramSet4 = slideDiagram.querySelector(`:scope ${".seq4-label-1"}`);
								slideDiagramSet5 = slideDiagram.querySelector(`:scope ${".seq5-heading-2"}`);
								slideDiagramSet6 = slideDiagram.querySelector(`:scope ${".seq6-graph-2"}`);
								slideDiagramSet7 = slideDiagram.querySelector(`:scope ${".seq7-label"}`);

								slideTimeline.fromTo(slideDiagramSet1, 1.5, { y: "50px", autoAlpha: 0}, { y: "0.46px", autoAlpha: 1, ease: ease }, "start+=1.75");

								slideTimeline.fromTo(slideDiagramSet2, 1.5, { y: "-50px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=1.85");
								slideTimeline.fromTo(slideDiagramSet3, 1.5, { y: "100px", autoAlpha: 0}, { y: "68.91px", autoAlpha: 1, ease: ease }, "start+=2.35");
								slideTimeline.fromTo(slideDiagramSet4, 1.5, { y: "10px", autoAlpha: 0}, { y: "23.98px", autoAlpha: 1, ease: ease }, "start+=2.75");
								slideTimeline.fromTo(slideDiagramSet5, 1.5, { y: "-50px", autoAlpha: 0}, { y: "0px", autoAlpha: 1, ease: ease }, "start+=3.1");

								slideTimeline.fromTo(slideDiagramSet6, 1.5, { y: "80px", autoAlpha: 0}, { y: "39.59px", autoAlpha: 1, ease: ease }, "start+=3.5");
								slideTimeline.fromTo(slideDiagramSet7, 1.5, { y: "10px", autoAlpha: 0}, { y: "23.98px", autoAlpha: 1, ease: ease }, "start+=4.15");
							}

							// slide #3 diagram animation

							else if( slideDiagram.classList.contains("diagram-3") ) {


								slideDiagramSet1 = slideDiagram.querySelector(`:scope ${".seq1-graph-base"}`);
								slideDiagramSet2 = slideDiagram.querySelector(`:scope ${".seq2-heading-1"}`);
								slideDiagramSet3 = slideDiagram.querySelector(`:scope ${".seq3-graph-1"}`);
								slideDiagramSet4 = slideDiagram.querySelector(`:scope ${".seq4-label-1"}`);
								slideDiagramSet5 = slideDiagram.querySelector(`:scope ${".seq5-heading-2"}`);
								slideDiagramSet6 = slideDiagram.querySelector(`:scope ${".seq6-graph-2"}`);
								slideDiagramSet7 = slideDiagram.querySelector(`:scope ${".seq7-label-2"}`);

								slideTimeline.fromTo(slideDiagramSet1, 1.5, { y: "50px", autoAlpha: 0}, { y: "0.45px", autoAlpha: 1, ease: ease }, "start+=1.75");

								slideTimeline.fromTo(slideDiagramSet2, 1.5, { y: "-50px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=1.85");
								slideTimeline.fromTo(slideDiagramSet3, 1.5, { y: "90px", autoAlpha: 0}, { y: "62.02px", autoAlpha: 1, ease: ease }, "start+=2.35");
								slideTimeline.fromTo(slideDiagramSet4, 1.5, { y: "60px", autoAlpha: 0}, { y: "24.15px", autoAlpha: 1, ease: ease }, "start+=2.75");
								slideTimeline.fromTo(slideDiagramSet5, 1.5, { y: "-50px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=3.1");

								slideTimeline.fromTo(slideDiagramSet6, 1.5, { y: "100px", autoAlpha: 0}, { y: "51.27px", autoAlpha: 1, ease: ease }, "start+=3.5");
								slideTimeline.fromTo(slideDiagramSet7, 1.5, { y: "60px", autoAlpha: 0}, { y: "23.47px", autoAlpha: 1, ease: ease }, "start+=4.15");
							}

							// slide #4 diagram animation

							else if( slideDiagram.classList.contains("diagram-4") ) {


								slideDiagramSet1 = slideDiagram.querySelector(`:scope ${".seq1-doted-grid"}`);
								slideDiagramSet2 = slideDiagram.querySelector(`:scope ${".seq2-lines"}`);
								slideDiagramSet3 = slideDiagram.querySelector(`:scope ${".seq3-txt"}`);
								slideDiagramSet4 = slideDiagram.querySelector(`:scope ${".seq4-txt"}`);
								slideDiagramSet5 = slideDiagram.querySelector(`:scope ${".seq5-zoom-in"}`);
								slideDiagramSet6 = slideDiagram.querySelector(`:scope ${".seq6-lines"}`);
								slideDiagramSet7 = slideDiagram.querySelector(`:scope ${".seq7-txt"}`);

								slideTimeline.fromTo(slideDiagramSet1, 1.5, { y: "-20px", autoAlpha: 0}, { y: "6.42px", autoAlpha: 1, ease: ease }, "start+=1.75");

								slideTimeline.fromTo(slideDiagramSet2, 1.5, { x: "430px", autoAlpha: 0}, { x: "370.27px", autoAlpha: 1, ease: ease }, "start+=1.85");
								slideTimeline.fromTo(slideDiagramSet3, 1.5, { y: "30px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=2.35");
								slideTimeline.fromTo(slideDiagramSet4, 1.5, { y: "280px", autoAlpha: 0}, { y: "240.07px", autoAlpha: 1, ease: ease }, "start+=2.75");
								slideTimeline.fromTo(slideDiagramSet5, 1.5, { y: "100px", autoAlpha: 0}, { y: "65.95px", autoAlpha: 1, ease: ease }, "start+=3.1");

								slideTimeline.fromTo(slideDiagramSet6, 1.5, { x: "400px", autoAlpha: 0}, { x: "370.27px", autoAlpha: 1, ease: ease }, "start+=3.5");
								slideTimeline.fromTo(slideDiagramSet7, 1.5, { y: "520px", autoAlpha: 0}, { y: "483.58px", autoAlpha: 1, ease: ease }, "start+=4.15");
							}

							// slide #5 diagram animation

							else if( slideDiagram.classList.contains("diagram-5") ) {


								slideDiagramSet1 = slideDiagram.querySelector(`:scope ${".seq1-header"}`);
								slideDiagramSet2 = slideDiagram.querySelectorAll(`:scope ${".seq2-blocks > g"}`);
								slideDiagramSet3 = slideDiagram.querySelectorAll(`:scope ${".seq3-labels > g"}`);
								slideDiagramSet4 = slideDiagram.querySelector(`:scope ${".seq4-separator"}`);
								slideDiagramSet5 = slideDiagram.querySelector(`:scope ${".seq5-header"}`);
								slideDiagramSet6 = slideDiagram.querySelectorAll(`:scope ${".seq6-blocks > g"}`);
								slideDiagramSet7 = slideDiagram.querySelectorAll(`:scope ${".seq7-labels > g"}`);

								slideTimeline.fromTo(slideDiagramSet1, 1.5, { y: "-20px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=1.75");
								slideTimeline.staggerFromTo(slideDiagramSet2, 0.35, { x: "40px", autoAlpha: 0 }, { x: "0.6px", autoAlpha: 1, ease: ease2}, 0.15, "start+=2");
								slideTimeline.staggerFromTo(slideDiagramSet3, 0.35, { x: "40px", autoAlpha: 0 }, { x: "28.37px", autoAlpha: 1, ease: ease2}, 0.15, "start+=2.1");

								slideTimeline.fromTo(slideDiagramSet4, 1.5, { y: "-20px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=3");

								slideTimeline.fromTo(slideDiagramSet5, 1.5, { y: "-20px", autoAlpha: 0}, { y: "0", autoAlpha: 1, ease: ease }, "start+=3.5");
								slideTimeline.staggerFromTo(slideDiagramSet6, 0.35, { x: "40px", autoAlpha: 0 }, { x: "2.59px", autoAlpha: 1, ease: ease2}, 0.15, "start+=4");
								slideTimeline.staggerFromTo(slideDiagramSet7, 0.35, { x: "40px", autoAlpha: 0 }, { x: "28.24px", autoAlpha: 1, ease: ease2}, 0.15, "start+=4.15");

							}

						}


						if (entry.intersectionRatio > 0) {
							slideObserver.unobserve(entry.target);
						}

					}
				})
			},
			{
				threshold: "0.35"
			});

			slideObserver.observe(el);


		});


		/***/ }),

	/***/ 										30:
	/***/ (function(module, exports) {

		// removed by extract-text-webpack-plugin

		/***/ }),

	/***/ 										64:
	/***/ (function(module, exports, __webpack_require__) {

		__webpack_require__(10);
		module.exports = __webpack_require__(30);


		/***/ })

},[64]);


(function () {

	"use strict";

	/**
	 * jump to download report section
	 */

	var jumpToReport = document.querySelector(".js-goto-report"),
		reportPanel = document.querySelector(".js-tru-form-section"),
		downloadPosition = reportPanel.getBoundingClientRect().top,
		downloadOffset = downloadPosition + window.pageYOffset - 80;

	jumpToReport.addEventListener("click", () => {
		window.scrollTo({
			top: downloadOffset,
			behavior: "smooth"
		});
	});

	/**
	 * slides paging
	 */

	var slideNumber, slideID, slide, slideOffset = "60", slidePosition, offsetPosition;

	document.querySelectorAll(".js-paging").forEach((el, i) => {

		el.addEventListener("click", () => {
			slideNumber = el.getAttribute('data-slide');
			console.log(slideNumber);
			slideID = ".js-slide-"+ slideNumber;
			slide = document.querySelector(slideID);
			slidePosition = slide.getBoundingClientRect().top;
			offsetPosition = slidePosition + window.pageYOffset - slideOffset;

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth"
			});
		});
	});

}());
